import React from 'react'
import '../styles/index.scss'
import JobsPage from './JobsPage'

function JobsContainer() {
    return (
        <div className='JobsContainer'>
            <JobsPage/>
        </div>
    )
}

export default JobsContainer